import JSZip from "jszip";

export async function filtetShpFile(file: File) {
    const validExtensions = [".shp", ".dbf", ".prj", ".shx", ".cpg"];
    const fileData = await file.arrayBuffer();
    const zip = await JSZip.loadAsync(fileData);
    for (const filename of Object.keys(zip.files)) {
        const fileExtension = filename
            .slice(filename.lastIndexOf("."))
            .toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
            zip.remove(filename);
        }
    }
    const filteredFile = await zip.generateAsync({ type: "arraybuffer" });
    return filteredFile;
}
